import { type OnboardingType } from '#app/__generated__/api.js';
import { type OnboardingFlowType } from '../types.js';

/**
 * Returns the onboarding flow type based on the specified type in
 * the url search parameter (e.g. `?userType=client`), or falls back
 * to the initial user onboarding type during sign up provided by API.
 */
export const getOnboardingFlowType = (
  profileOnboardingType: OnboardingType,
  urlSearchParameterUserType?: null | string,
): OnboardingFlowType => {
  if (
    urlSearchParameterUserType === 'client' ||
    urlSearchParameterUserType === 'independent'
  ) {
    return urlSearchParameterUserType;
  }

  if (profileOnboardingType === 'CLIENT') {
    return 'client';
  }

  return 'independent';
};
